import React, { useRef } from 'react';
import { Row } from 'react-table';

import { useStores } from 'bringg-web/recipes';
import { RenderRowProps, ListChildRowMemo } from 'bringg-web/components/bringg-react-table';
import useInView, { ObserverId } from '../hooks/use-in-view';
import { NEW_ALERT_CLASS } from '../consts';
import type { ElasticAlert } from '../../../types/common.consts';

const InViewRow = (props: RenderRowProps<Row<ElasticAlert>[]>) => {
	const ref = useRef<HTMLDivElement>(null);
	const { data, index } = props;
	const {
		alertsViewStore: { unseenAlertsManager }
	} = useStores();
	const { id } = data[index];
	const isAlertNew = unseenAlertsManager.allNewAlerts.has(id);

	useInView(ref, ObserverId.AlertsScreen, !isAlertNew);

	return <ListChildRowMemo ref={ref} {...props} className={isAlertNew ? NEW_ALERT_CLASS : undefined} />;
};

// Should be fine to not use observer here as we vivisect the class from the element directly
export default InViewRow;
